import { AxiosError } from 'axios'
import i18n from 'i18next'
import { is, mapObjIndexed } from 'ramda'
import { toast } from 'react-toastify'

export type ApiErrors = string[] | Record<string, string[] | string>

const showErrorsFromArrayOfStrings = (arrayOfStrings: string[]) =>
  arrayOfStrings.map((e) => toast.error(e))

export const handleApiErrors = (error: AxiosError<ApiErrors, unknown>) => {
  const { response } = error

  if (response && response.status >= 500) {
    toast.error(i18n.t<string>('Internal server error'))
  }

  if (response && response.status >= 400 && response.status <= 499) {
    const { data } = response

    if (is(Array, data) && data.length) {
      showErrorsFromArrayOfStrings(data)
    }

    if (is(Object, data) && !is(Array, data) && data !== null) {
      mapObjIndexed(
        (err) =>
          is(String, err)
            ? toast.error(err)
            : showErrorsFromArrayOfStrings(err),
        data
      )
    }
  }
}
